const sectionsToRender = [
  {
    id: '#CartDrawer-Header',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Header'
  },
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  },
  {
    id: '#CartDrawer-Summary',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Summary'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.style.visibility = 'visible';
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('#CartDrawer-Body'));
  }

  close() {
    this.classList.remove('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.style.visibility = 'hidden';
      },
      { once: true }
    );
    removeTrapFocus(this.activeElement);
    bodyScroll.unlock(this.querySelector('#CartDrawer-Body'));
    this.querySelector('#CartDrawer-Body').scrollTop = 0;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.querySelector('#CartDrawer');
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response) {
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);





// --- CUSTOM CART DRAWER & MAIN CART DISCOUNT LOGIC ---
document.addEventListener('click', function(e) {
  
  // Traffic Controller: Are we on the full cart page or in the drawer?
  const isCartPage = window.location.pathname.includes('/cart');

  // --- 1. APPLY BUTTON LOGIC ---
  if (e.target && e.target.id === 'drawer-discount-btn') {
    e.preventDefault();
    
    const btn = e.target;
    // Look specifically inside the box the user clicked to avoid grabbing the hidden drawer
    const wrapper = btn.closest('.custom-discount-wrapper');
    const input = wrapper.querySelector('#drawer-discount-input');
    const messageEl = wrapper.querySelector('#discount-message');
    const discountCode = input ? input.value.trim() : '';

    if (messageEl) messageEl.style.display = 'none';

    if (!discountCode) {
      if (messageEl) {
        messageEl.innerText = "Please enter a promo code.";
        messageEl.style.display = 'block';
      }
      return;
    }

    btn.innerText = "APPLYING...";

    // Prepare the server request
    let fetchBody = { discount: discountCode };
    // Only ask for drawer HTML if we are actually in the drawer
    if (!isCartPage) {
      fetchBody.sections = 'cart-drawer';
    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fetchBody)
    })
    .then(response => response.json())
    .then(parsedState => {
      if (parsedState.total_discount > 0) {
        
        if (isCartPage) {
          // If on the full cart page, do a seamless native reload to update all product grids and totals
          window.location.reload();
        } else {
          // If in the drawer, swap the HTML smoothly
          const parsedHtml = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
          const bodyHtml = parsedHtml.querySelector('#CartDrawer-Body');
          const summaryHtml = parsedHtml.querySelector('#CartDrawer-Summary');
          
          if (bodyHtml) document.querySelector('#CartDrawer-Body').innerHTML = bodyHtml.innerHTML;
          if (summaryHtml) document.querySelector('#CartDrawer-Summary').innerHTML = summaryHtml.innerHTML;
        }

      } else {
        btn.innerText = "APPLY";
        if (messageEl) {
          messageEl.innerText = "Code is invalid or does not apply.";
          messageEl.style.display = 'block';
        }
      }
    })
    .catch(error => {
      console.error('Error applying discount:', error);
      btn.innerText = "APPLY";
    });
  }

  // --- 2. REMOVE BUTTON LOGIC ---
  if (e.target && e.target.id === 'remove-discount-btn') {
    e.preventDefault();
    
    const btn = e.target;
    btn.innerText = "REMOVING...";

    let fetchBody = { discount: "" };
    if (!isCartPage) {
      fetchBody.sections = 'cart-drawer';
    }

    // Ask Shopify to clear the code
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fetchBody)
    })
    .then(response => response.json())
    .then(parsedState => {
      
      if (isCartPage) {
        // If on the full cart page, reload to clear all tags and reset prices
        window.location.reload();
      } else {
        // If in the drawer, swap the HTML smoothly back to normal
        const parsedHtml = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
        const bodyHtml = parsedHtml.querySelector('#CartDrawer-Body');
        const summaryHtml = parsedHtml.querySelector('#CartDrawer-Summary');
        
        if (bodyHtml) document.querySelector('#CartDrawer-Body').innerHTML = bodyHtml.innerHTML;
        if (summaryHtml) document.querySelector('#CartDrawer-Summary').innerHTML = summaryHtml.innerHTML;
      }
    })
    .catch(error => {
      console.error('Error removing discount:', error);
      btn.innerText = "REMOVE";
    });
  }
});
// --- END CUSTOM CART DRAWER & MAIN CART DISCOUNT LOGIC ---